import { Box, BoxProps } from 'styled-system/jsx';
import { ReactNode } from 'react';

const FixToBottom = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: BoxProps['className'];
}) => {
  return (
    <Box
      position="fixed"
      right="0"
      left="0"
      zIndex="layout"
      className={className}
    >
      <Box maxWidth="maxContainer" width="90%" py="10px" mx="auto">
        {children}
      </Box>
    </Box>
  );
};
export default FixToBottom;
